import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';


const RenderTextFieldReduxNumber = ({ input, label, name, type, withFocus, autoFocus, textTransform, meta: { touched, error }, maxLength }) => {
  const handleChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, '');
    

    input.onChange(inputValue);
  };

  return (
    <div>
      <TextField
        {...input}
        type={!type ? 'text' : type}
        fullWidth
        autoFocus={autoFocus}
        autoComplete="off"
        InputLabelProps={{
          // style: { color: '#000000' },
        }}
        inputProps={{
          ...(type === 'number' ? {} : { style: { textTransform: textTransform || 'uppercase' } }),
          maxLength,
        }}
        label={label}
        onChange={handleChange}
      />
      {touched && error && <span style={{ color: 'red' }}>{error}</span>}
    </div>
  );
};

RenderTextFieldReduxNumber.propTypes = {
  label: PropTypes.string.isRequired
};

export default RenderTextFieldReduxNumber;
